import React from 'react';

import { METABOX_DEFAULT_VARIANT, MetaboxVariants } from '@life-moments/lifehub-components';

import { getStructureItemLayers, StructureItemLayer } from '~/pages/blocks/edit/components/structure-sidebar/helpers';

import { Block } from '~/types/gists/Block';

import Variant from '~/pages/blocks/edit/components/structure-sidebar/components/variant';

import styles from './styles.module.scss';

type Props = {
  variants: MetaboxVariants[];
  blockName: Block['name'];
};

const content: StructureItemLayer[] = [
  {
    name: 'Inner',
    childrenLayers: [{ name: 'Label' }, { name: 'Date' }]
  }
];

const MetaboxBlockVariants = ({ variants, blockName }: Props): React.JSX.Element => (
  <div className={styles.container}>
    {variants.map(variant => (
      <Variant
        key={variant.name}
        name={variant.displayName}
        isDefault={variant.name === METABOX_DEFAULT_VARIANT.name}
        content={getStructureItemLayers(blockName, content)}
      />
    ))}
  </div>
);

export default MetaboxBlockVariants;
